export const MODEL_NAME = 'processInstanceNumbering';

export const ROUTES = {
  instanceNumbering: (processId) => `process/${processId}/instanceNumbering`,
};
